import wallet from './wallet';
import claim from './claim';

export default {
    WALLET: wallet,
    CLAIM: claim,
}